import studyResultsColumns from './study-results-columns'
export default () => ({
  jurisdiction: false,
  studyResultsColumns
})